const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20round%20icon%20with%20warm%20gradient%20colors%2C%20modern%20minimal%20design%2C%20soft%20geometric%20pattern%2C%20dark%20background%20with%20amber%20and%20coral%20tones&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '黑料在线的更新速度真的没话说！每天都能在这里看到最新的大瓜，黑料视频在线免费观看体验也很流畅，比那些需要跳来跳去的平台强太多了。推荐给身边所有爱吃瓜的朋友了！',
    likes: '2.3k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20round%20icon%20with%20cool%20gradient%20colors%2C%20modern%20minimal%20design%2C%20soft%20geometric%20pattern%2C%20dark%20background%20with%20slate%20and%20teal%20tones&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '一直在找能稳定在线观看黑料的平台，试了好几个都不太行。黑料在线这个站不错，视频加载很快，画质也清晰，关键是每天都有新内容，现在已经是我的每日必刷了。',
    likes: '1.8k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20round%20icon%20with%20vibrant%20gradient%20colors%2C%20modern%20minimal%20design%2C%20soft%20geometric%20pattern%2C%20dark%20background%20with%20rose%20and%20gold%20tones&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '八卦小雷达',
    time: '8小时前',
    content: '内容覆盖真的很全，从网红到明星，从综艺到选秀，基本上我想看的黑料视频这里都能找到。黑料在线播放不卡顿，也没有烦人的弹窗广告，吃瓜体验满分。',
    likes: '1.5k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20round%20icon%20with%20earthy%20gradient%20colors%2C%20modern%20minimal%20design%2C%20soft%20geometric%20pattern%2C%20dark%20background%20with%20olive%20and%20copper%20tones&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '真相挖掘机',
    time: '12小时前',
    content: '关注黑料在线已经半年了，这个平台的深度扒皮内容做得特别好，不是那种标题党，而是真的有料。希望继续保持这种风格，给大家带来更多真实的黑料爆料！',
    likes: '980',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            听听吃瓜群众对黑料在线的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}